import React from 'react';
import { ChooseProject, Support, Share } from './';
import { Colors, Container, device, Section, TitleBanner } from 'utils';
import styled from '@emotion/styled';
const HowToSupportWrapper = styled.div`
  text-align: center;
  h1 {
    margin-bottom: 50px;
  }
`;

const SectionTitle = styled.div`
  h3 {
    display: inline-block;
    position: relative;
    font-size: 65px;
    font-weight: 600;
    margin-bottom: 38px;
    margin-top: 0;
    line-height: 1;
    color: ${(props) => (props.color ? `${props.color}` : Colors.white)};
    @media ${device.allMobile} {
      font-size: 30px;
    }
    @media ${device.laptop} {
      font-size: 30px;
    }
  }
`;
export default function HowToSupport() {
  return (
    <Section>
      <HowToSupportWrapper>
        <Container>
          <>
            <SectionTitle color={Colors.GreenColor}>
              <h3>Wie unterstützt du ein Projekt?</h3>
            </SectionTitle>
            <ChooseProject />
          </>
        </Container>
        <Support />
        <Container>
          <Share />
        </Container>
      </HowToSupportWrapper>
    </Section>
  );
}
